<template>
  <div class="content dashboard">
    <h1><span>Dashboard</span></h1>

    <b-tabs pills nav-class="mb-3 mt-5" lazy v-model="activeTab" @input="changeRouter">
      <b-tab title="Geral" @click="changeRouter">
        <dashboard-geral />
      </b-tab>
      <b-tab title="Usuários" @click="changeRouter" v-if="isAdmin || isMaster || isAdminRestrito || isAnalista">
        <dashboard-usuarios />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import DashboardGeral from '@/modules/Dashboard/components/DashboardGeral'
import DashboardUsuarios from '@/modules/Dashboard/components/DashboardUsuarios'
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import LoginUtils from '@/core/util/login-utils'

export default {
  name: 'DashboardView',
  components: { DashboardUsuarios, DashboardGeral },

  data () {
    return {
      activeTab: 0
    }
  },

  mounted () {
    if (this.$route.params.activeTab) {
      switch (this.$route.params.activeTab) {
        case 'geral':
          this.activeTab = 0
          break
        case 'usuarios':
          this.activeTab = 1
          break
        default:
          this.activeTab = 0
      }
    }
  },

  computed: {
    isMaster: function () {
      return TipoPerfilUtil.isMaster(LoginUtils.getUsuario().perfil_id)
    },

    isAdmin: function () {
      return TipoPerfilUtil.isAdmin(LoginUtils.getUsuario().perfil_id)
    },

    isAdminRestrito: function () {
      return TipoPerfilUtil.isAdminRestrito(LoginUtils.getUsuario().perfil_id)
    },

    isAnalista: function () {
      return TipoPerfilUtil.isAnalista(LoginUtils.getUsuario().perfil_id)
    }
  },

  methods: {
    changeRouter: function (index) {
      switch (index) {
        case 0:
          this.$router.push('/dashboard/geral')
          break
        case 1:
          this.$router.push('/dashboard/usuarios')
          break
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~chartist/dist/scss/settings/chartist-settings";

  .ct-legend {
    position: relative;
    z-index: 10;
    text-align: center;

    li {
      position: relative;
      padding-left: 23px;
      margin-bottom: 3px;
      display: inline-block;
      margin-right: 10px;
    }

    li:before {
      width: 12px;
      height: 12px;
      position: absolute;
      left: 0;
      content: '';
      border: 3px solid transparent;
      border-radius: 2px;
    }

    li.inactive:before {
      background: transparent;
    }

    &.ct-legend-inside {
       position: absolute;
       top: 0;
       right: 0;
     }

    .ct-series-0:before {
      background-color: #7C56F6;
      border-color: #7C56F6;
    }

    .ct-series-1:before {
      background-color: #4DCDCC;
      border-color: #4DCDCC;
    }
  }
</style>
